<ng-template [spinnerLoader]="companiesResource() === undefined" [size]="'sm'"></ng-template>

<label for="companySelect" class="form-label">
    {{label()}} @if(isRequired()){*}
</label>

<select id="companySelect" 
        class="form-select" 
        [value]="value() ?? ''" 
        [disabled]="isDisabled()" 
        (change)="onSelectionChange($event)" 
        (blur)="onBlur()" 
        [class.is-invalid]="isInvalid()">


     @if (companiesResource(); as companies) {

        @if (companies.length > 0) {
            <option value="">
                {{ isVisibleOptionAll() ? 'Tutte le aziende' : 'Seleziona Azienda' }}
            </option>
        }

        @for (item of companies; track item.id) {
            <option [value]="item.id" [selected]="(item.id + '') === value()">{{ item.nomeCompleto }}</option>
        } @empty {
            <option value="" disabled>
                Nessun {{ label() }} presente
            </option>
        }
    } @else {
        <option value="" disabled selected>
        Caricamento in corso...
        </option>
    } 
</select>
@for (error of errors(); track $index) {
    <div class="invalid-feedback">{{ error.message }}</div>
}